import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./SignUp.css";

const generateLicenseKey = () => {
  const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const randomLetters = letters.charAt(Math.floor(Math.random() * 26)) 
                      + letters.charAt(Math.floor(Math.random() * 26));
  const randomNumbers = Math.floor(10000 + Math.random() * 90000); // 5 digits
  return `${randomLetters}${randomNumbers}`;
};

const checkLicenseUnique = async (key) => {
  try {
    const res = await fetch(`https://senu-app.azurewebsites.net/api/users/check-license?licenseKey=${key}`);
    const data = await res.json();
    return data.isAvailable; // backend should return { isAvailable: true/false }
  } catch (err) {
    console.error("License check failed:", err);
    return false;
  }
};


const SignUp = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    phone: "",
    licenseKey: "",
    acceptedTerms: false,
  });


  const [message, setMessage] = useState("");

  React.useEffect(() => {
  const generateUniqueKey = async () => {
    let key, available = false;
    while (!available) {
      key = generateLicenseKey();
      available = await checkLicenseUnique(key);
    }
    setFormData(prev => ({ ...prev, licenseKey: key }));
  };

  generateUniqueKey();
}, []);


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.acceptedTerms) {
      setMessage("You must accept the Terms and Privacy Policy.");
      return;
    }

    try {
      console.log("Submitting data:", formData);

      const response = await fetch("https://senu-app.azurewebsites.net/api/users/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          password: formData.password,
          phone: formData.phone,
          licenseKey: formData.licenseKey,
        }),
      });
      console.log("Submitting LicenseKey:", formData.licenseKey);
      
      const result = await response.json();
      console.log("Backend response:", result);

      if (response.ok) {
        setMessage("✅ Registered successfully!");
        setFormData({
          name: "",
          email: "",
          password: "",
          phone: "",
          licenseKey: "",
          acceptedTerms: false,
        });
      } else {
        setMessage(`❌ Error: ${result.message || "Registration failed"}`);
      }
    } catch (error) {
      setMessage("❌ Network error: Could not connect to the server");
    }
  };

  return (
    <div className="signup-container">
      <h2 className="signup-title">Create Account</h2>
      <form className="signup-form" onSubmit={handleSubmit}>
        <input
          name="name"
          type="text"
          placeholder="Full Name"
          className="signup-input"
          value={formData.name}
          onChange={handleChange}
          
        />
        <input
          name="email"
          type="email"
          placeholder="Enter Username or Email"
          className="signup-input"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <input
          name="password"
          type="password"
          placeholder="Enter Password"
          className="signup-input"
          value={formData.password}
          onChange={handleChange}
          required
        />
        <input
          name="phone"
          type="text"
          placeholder="Enter Phone Number"
          className="signup-input"
          value={formData.phone}
          onChange={handleChange}
          required
        />
        <input
          name="licenseKey"
          type="text"
          placeholder="License Key"
          className="signup-input"
          value={formData.licenseKey}
          onChange={handleChange}
          required
        />

        <div className="terms-container" style={{ margin: "10px 0", fontSize: "0.9rem", color: "#fff" }}>
          <input
            name="acceptedTerms"
            type="checkbox"
            id="terms"
            checked={formData.acceptedTerms}
            onChange={handleChange}
            
          />
          <label htmlFor="terms" style={{ marginLeft: "8px", color: "white" }}>
            I agree to the{" "}
            <Link to="/terms" style={{ color: "#007bff" }}>Terms and Conditions</Link> and{" "}
            <Link to="/privacy" style={{ color: "#007bff" }}>Privacy Policy</Link>
          </label>
        </div>

        <button type="submit" className="signup-button">Sign Up</button>
      </form>

      {message && <p style={{ marginTop: "10px", color: "lightyellow" }}>{message}</p>}

      <p className="login-text">
        Already have an account? <Link to="/">Log In</Link>
      </p>
    </div>
  );
};

export default SignUp;
